import { API_BASE } from '../services/api';

/** Rutas de uploads servidas por nginx en el mismo origen (sin prefijo /api). */
const UPLOAD_PREFIX = '/uploads/';

function siteOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/+$/, '');
  }
  return API_BASE.replace(/\/api\/?$/i, '');
}

/** URL absoluta para imágenes del API (/uploads/...) o URLs externas. */
export function resolveMediaUrl(src) {
  const s = String(src || '').trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s) || s.startsWith('data:')) return s;

  const normalized = s.startsWith('/') ? s : `/${s}`;

  // En split prod nginx expone /uploads/* al contenedor correcto.
  // NUNCA usar /api/uploads — cae en d28d-core y el archivo vive en shell-backend.
  if (normalized.startsWith(UPLOAD_PREFIX)) {
    return `${siteOrigin()}${normalized}`;
  }

  const origin = siteOrigin();
  return `${origin}${normalized}`;
}
